function DrinkItem(drinks) {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row ">
        <h1 className="mb-10 text-xl font-extrabold md:text-2xl lg:text-4xl">
          {drinks.title}
        </h1>
        <span className="ml-auto text-xl md:text-2xl lg:text-4xl mb-[20px] font-extrabold">
          ${drinks.drinks[0].price.toFixed(2)}
        </span>
      </div>

      <div className="grid grid-cols-1 px-4 gap-x-3 md:grid-cols-2">
        {drinks.drinks &&
          drinks.drinks.map((drink) => (
            <div>
              <p className="md:text-sm lg:text-lg">{drink.engName}</p>
            </div>
          ))}
      </div>
    </div>
  );
}

export default DrinkItem;
